 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"APIManagement":"APIManagement","Accelerator":"Accelerator","ActPage":"ActPage","Address":"Address","AntiFake":"AntiFake","BrandKit":"BrandKit","ButtonOnce":"ButtonOnce","Careers":"Careers","CertificationPersonal~DaoProposal~NftInformation":"CertificationPersonal~DaoProposal~NftInformation","CertificationPersonal":"CertificationPersonal","DaoProposal~NftInformation":"DaoProposal~NftInformation","DaoProposal":"DaoProposal","DownLoad":"DownLoad","ForgotPassword~Invitation~Nft~NftAsset~NftCollection~NftDetail~NftHistory~NftInformation~NftList~Sec~e2dfdbba":"ForgotPassword~Invitation~Nft~NftAsset~NftCollection~NftDetail~NftHistory~NftInformation~NftList~Sec~e2dfdbba","NftInformation":"NftInformation","ForgotPassword~SignIn~SignUp":"ForgotPassword~SignIn~SignUp","ForgotPassword":"ForgotPassword","SignUp":"SignUp","Nft":"Nft","NftAsset~NftCollection~NftHistory":"NftAsset~NftCollection~NftHistory","NftAsset":"NftAsset","NftCollection":"NftCollection","NftHistory":"NftHistory","NftDetail":"NftDetail","NftList":"NftList","Security":"Security","SignIn":"SignIn","Home~earn":"Home~earn","Home":"Home","IeoDetail":"IeoDetail","IeoHome":"IeoHome","Lang-ar":"Lang-ar","Lang-de":"Lang-de","Lang-en":"Lang-en","Lang-es":"Lang-es","Lang-fa":"Lang-fa","Lang-hi":"Lang-hi","Lang-it":"Lang-it","Lang-ja":"Lang-ja","Lang-ko":"Lang-ko","Lang-ma":"Lang-ma","Lang-pt":"Lang-pt","Lang-ru":"Lang-ru","Lang-tr":"Lang-tr","Lang-vi-VN":"Lang-vi-VN","Lang-zh-hans":"Lang-zh-hans","Lang-zh-hant":"Lang-zh-hant","Launchpad":"Launchpad","Listings~Markets":"Listings~Markets","Listings":"Listings","Markets":"Markets","Loading":"Loading","NftWithdraw":"NftWithdraw","Novice":"Novice","Overlay":"Overlay","OverlayConfirm":"OverlayConfirm","Payments":"Payments","UserCenter":"UserCenter","WithDraw":"WithDraw","ambassadorPage":"ambassadorPage","blog-detail":"blog-detail","blog-home":"blog-home","Dao":"Dao","DaoList":"DaoList","earn":"earn","Invitation":"Invitation","Kickstarter~KickstarterDeatil":"Kickstarter~KickstarterDeatil","Kickstarter":"Kickstarter","KickstarterDeatil":"KickstarterDeatil","DaoDetail":"DaoDetail","user-center-profile":"user-center-profile","Deposit":"Deposit","coupons":"coupons","identity":"identity","launchpadDetail~launchpadPlut":"launchpadDetail~launchpadPlut","launchpadDetail":"launchpadDetail","launchpadPlut":"launchpadPlut","live":"live","union-referral":"union-referral","user-center-frame":"user-center-frame"}[chunkId]||chunkId) + "." + {"APIManagement":"8800a6a5","Accelerator":"edfb6369","ActPage":"cca7ee73","Address":"78a880cb","AntiFake":"79b5bfbe","BrandKit":"1f71e5b7","ButtonOnce":"37af5b66","Careers":"52fb9353","CertificationPersonal~DaoProposal~NftInformation":"39599be7","CertificationPersonal":"34476c2f","chunk-7c2f5d8a":"6f0552d6","DaoProposal~NftInformation":"a72a3c75","DaoProposal":"7bdaf220","DownLoad":"a677b07d","ForgotPassword~Invitation~Nft~NftAsset~NftCollection~NftDetail~NftHistory~NftInformation~NftList~Sec~e2dfdbba":"24cac2ea","NftInformation":"581cd320","ForgotPassword~SignIn~SignUp":"6ba370fe","ForgotPassword":"35fa6eac","SignUp":"f02de634","Nft":"1608a8fa","NftAsset~NftCollection~NftHistory":"3a09cf86","NftAsset":"2fbedb32","NftCollection":"7d0dec67","NftHistory":"7f245432","NftDetail":"1413474a","NftList":"0f3be007","Security":"2bd38ca9","SignIn":"b5ed2f98","Home~earn":"5b91e91a","Home":"bbd1ab2e","IeoDetail":"2af46d18","IeoHome":"68c0f53b","Lang-ar":"1f562958","Lang-de":"1ea05f03","Lang-en":"79c0c76c","Lang-es":"08aacc01","Lang-fa":"e691755b","Lang-hi":"1e7febcb","Lang-it":"dea56b86","Lang-ja":"db82faa0","Lang-ko":"f25be1d7","Lang-ma":"485580ac","Lang-pt":"49f87fdf","Lang-ru":"528990e6","Lang-tr":"46ca5f69","Lang-vi-VN":"d09602fd","Lang-zh-hans":"e4b824b6","Lang-zh-hant":"8c60c552","Launchpad":"a2e4ed7b","Listings~Markets":"39d7b205","Listings":"4b7427b4","Markets":"796339ca","Loading":"784087ae","NftWithdraw":"ea874cd3","Novice":"29243475","Overlay":"238156ea","OverlayConfirm":"7e5abf62","Payments":"71002373","UserCenter":"42da5085","WithDraw":"7f10950e","ambassadorPage":"d0fc50dc","blog-detail":"f3733a3e","blog-home":"a9754a43","chunk-08f6736c":"76e90015","Dao":"bf04eb90","DaoList":"b41aa320","earn":"60932644","chunk-3a46add8":"d9ee4fa4","Invitation":"28b22da0","chunk-140421f0":"4ddedd96","chunk-56059747":"abe6a03f","chunk-636763b6":"747114db","chunk-8a1c44bc":"ab5d7f0a","chunk-dac0d122":"de588056","chunk-93de0436":"af35c8a3","Kickstarter~KickstarterDeatil":"a91569ed","Kickstarter":"93aa385f","KickstarterDeatil":"0431c18e","chunk-d1bf9074":"37997cde","chunk-095f1666":"64ff964a","DaoDetail":"d3297ae5","chunk-321fd90c":"14092a5b","user-center-profile":"e267fd8b","chunk-203f7664":"e106daef","chunk-2de1ca5a":"df81da30","chunk-3c80c2de":"c8fdd2c1","chunk-647569e0":"8b56e8b9","chunk-7c11d3c3":"70ce3523","chunk-6483a0be":"b2b36f4d","Deposit":"618502a2","chunk-ab0a0336":"894f2b74","chunk-acfb8b64":"026dd289","coupons":"95b1dc5c","identity":"8e6e6bd3","launchpadDetail~launchpadPlut":"0eced549","launchpadDetail":"43509129","launchpadPlut":"b0dab122","live":"1b8f5504","union-referral":"1e007735","user-center-frame":"4114e975"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"APIManagement":1,"Accelerator":1,"ActPage":1,"AntiFake":1,"BrandKit":1,"ButtonOnce":1,"Careers":1,"CertificationPersonal":1,"chunk-7c2f5d8a":1,"DaoProposal~NftInformation":1,"DaoProposal":1,"DownLoad":1,"ForgotPassword~SignIn~SignUp":1,"SignUp":1,"Nft":1,"NftAsset~NftCollection~NftHistory":1,"NftDetail":1,"Security":1,"SignIn":1,"Home~earn":1,"Home":1,"IeoDetail":1,"IeoHome":1,"Launchpad":1,"Markets":1,"Loading":1,"Novice":1,"Payments":1,"WithDraw":1,"blog-detail":1,"blog-home":1,"Dao":1,"DaoList":1,"earn":1,"chunk-3a46add8":1,"Invitation":1,"chunk-140421f0":1,"chunk-636763b6":1,"chunk-8a1c44bc":1,"chunk-dac0d122":1,"Kickstarter~KickstarterDeatil":1,"Kickstarter":1,"KickstarterDeatil":1,"chunk-d1bf9074":1,"chunk-095f1666":1,"DaoDetail":1,"chunk-321fd90c":1,"user-center-profile":1,"chunk-203f7664":1,"chunk-3c80c2de":1,"chunk-6483a0be":1,"Deposit":1,"chunk-acfb8b64":1,"identity":1,"live":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"APIManagement":"APIManagement","Accelerator":"Accelerator","ActPage":"ActPage","Address":"Address","AntiFake":"AntiFake","BrandKit":"BrandKit","ButtonOnce":"ButtonOnce","Careers":"Careers","CertificationPersonal~DaoProposal~NftInformation":"CertificationPersonal~DaoProposal~NftInformation","CertificationPersonal":"CertificationPersonal","DaoProposal~NftInformation":"DaoProposal~NftInformation","DaoProposal":"DaoProposal","DownLoad":"DownLoad","ForgotPassword~Invitation~Nft~NftAsset~NftCollection~NftDetail~NftHistory~NftInformation~NftList~Sec~e2dfdbba":"ForgotPassword~Invitation~Nft~NftAsset~NftCollection~NftDetail~NftHistory~NftInformation~NftList~Sec~e2dfdbba","NftInformation":"NftInformation","ForgotPassword~SignIn~SignUp":"ForgotPassword~SignIn~SignUp","ForgotPassword":"ForgotPassword","SignUp":"SignUp","Nft":"Nft","NftAsset~NftCollection~NftHistory":"NftAsset~NftCollection~NftHistory","NftAsset":"NftAsset","NftCollection":"NftCollection","NftHistory":"NftHistory","NftDetail":"NftDetail","NftList":"NftList","Security":"Security","SignIn":"SignIn","Home~earn":"Home~earn","Home":"Home","IeoDetail":"IeoDetail","IeoHome":"IeoHome","Lang-ar":"Lang-ar","Lang-de":"Lang-de","Lang-en":"Lang-en","Lang-es":"Lang-es","Lang-fa":"Lang-fa","Lang-hi":"Lang-hi","Lang-it":"Lang-it","Lang-ja":"Lang-ja","Lang-ko":"Lang-ko","Lang-ma":"Lang-ma","Lang-pt":"Lang-pt","Lang-ru":"Lang-ru","Lang-tr":"Lang-tr","Lang-vi-VN":"Lang-vi-VN","Lang-zh-hans":"Lang-zh-hans","Lang-zh-hant":"Lang-zh-hant","Launchpad":"Launchpad","Listings~Markets":"Listings~Markets","Listings":"Listings","Markets":"Markets","Loading":"Loading","NftWithdraw":"NftWithdraw","Novice":"Novice","Overlay":"Overlay","OverlayConfirm":"OverlayConfirm","Payments":"Payments","UserCenter":"UserCenter","WithDraw":"WithDraw","ambassadorPage":"ambassadorPage","blog-detail":"blog-detail","blog-home":"blog-home","Dao":"Dao","DaoList":"DaoList","earn":"earn","Invitation":"Invitation","Kickstarter~KickstarterDeatil":"Kickstarter~KickstarterDeatil","Kickstarter":"Kickstarter","KickstarterDeatil":"KickstarterDeatil","DaoDetail":"DaoDetail","user-center-profile":"user-center-profile","Deposit":"Deposit","coupons":"coupons","identity":"identity","launchpadDetail~launchpadPlut":"launchpadDetail~launchpadPlut","launchpadDetail":"launchpadDetail","launchpadPlut":"launchpadPlut","live":"live","union-referral":"union-referral","user-center-frame":"user-center-frame"}[chunkId]||chunkId) + "." + {"APIManagement":"cd708045","Accelerator":"f2941883","ActPage":"59052e8b","Address":"31d6cfe0","AntiFake":"36abd619","BrandKit":"0c50ac9c","ButtonOnce":"515de884","Careers":"c7995482","CertificationPersonal~DaoProposal~NftInformation":"31d6cfe0","CertificationPersonal":"797a94c8","chunk-7c2f5d8a":"5c141721","DaoProposal~NftInformation":"ae241f74","DaoProposal":"a5934aed","DownLoad":"20196083","ForgotPassword~Invitation~Nft~NftAsset~NftCollection~NftDetail~NftHistory~NftInformation~NftList~Sec~e2dfdbba":"31d6cfe0","NftInformation":"31d6cfe0","ForgotPassword~SignIn~SignUp":"6472866b","ForgotPassword":"31d6cfe0","SignUp":"81b83b4d","Nft":"a1a9c9ef","NftAsset~NftCollection~NftHistory":"3f7f2c6c","NftAsset":"31d6cfe0","NftCollection":"31d6cfe0","NftHistory":"31d6cfe0","NftDetail":"a86ed9a8","NftList":"31d6cfe0","Security":"59d48ed4","SignIn":"81b83b4d","Home~earn":"4d609d28","Home":"3b8d3bd4","IeoDetail":"a533e498","IeoHome":"fb542b8a","Lang-ar":"31d6cfe0","Lang-de":"31d6cfe0","Lang-en":"31d6cfe0","Lang-es":"31d6cfe0","Lang-fa":"31d6cfe0","Lang-hi":"31d6cfe0","Lang-it":"31d6cfe0","Lang-ja":"31d6cfe0","Lang-ko":"31d6cfe0","Lang-ma":"31d6cfe0","Lang-pt":"31d6cfe0","Lang-ru":"31d6cfe0","Lang-tr":"31d6cfe0","Lang-vi-VN":"31d6cfe0","Lang-zh-hans":"31d6cfe0","Lang-zh-hant":"31d6cfe0","Launchpad":"c1ca6b7f","Listings~Markets":"31d6cfe0","Listings":"31d6cfe0","Markets":"a86ed9a8","Loading":"c0f684de","NftWithdraw":"31d6cfe0","Novice":"a6f59385","Overlay":"31d6cfe0","OverlayConfirm":"31d6cfe0","Payments":"8971c06d","UserCenter":"31d6cfe0","WithDraw":"45716b52","ambassadorPage":"31d6cfe0","blog-detail":"5edf1bbe","blog-home":"105ec64e","chunk-08f6736c":"31d6cfe0","Dao":"421ac8a8","DaoList":"db86e518","earn":"a906355f","chunk-3a46add8":"eae80702","Invitation":"a86ed9a8","chunk-140421f0":"8796b59f","chunk-56059747":"31d6cfe0","chunk-636763b6":"348b96eb","chunk-8a1c44bc":"b54c08f9","chunk-dac0d122":"113f28b3","chunk-93de0436":"31d6cfe0","Kickstarter~KickstarterDeatil":"3dec8438","Kickstarter":"9d6090a2","KickstarterDeatil":"b2cd5f6f","chunk-d1bf9074":"7e1eae73","chunk-095f1666":"9bbc9761","DaoDetail":"4dfdfb17","chunk-321fd90c":"8d602cb3","user-center-profile":"a86ed9a8","chunk-203f7664":"3fb3644a","chunk-2de1ca5a":"31d6cfe0","chunk-3c80c2de":"699262d8","chunk-647569e0":"31d6cfe0","chunk-7c11d3c3":"31d6cfe0","chunk-6483a0be":"af3d4340","Deposit":"527c612e","chunk-ab0a0336":"31d6cfe0","chunk-acfb8b64":"9843e521","coupons":"31d6cfe0","identity":"fc8711a1","launchpadDetail~launchpadPlut":"31d6cfe0","launchpadDetail":"31d6cfe0","launchpadPlut":"31d6cfe0","live":"8f0574d2","union-referral":"31d6cfe0","user-center-frame":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
